<template>
  <div class="content">
    <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <div class="pop" style="padding: 37px 28px">
      <div style="border-bottom: 1px solid #eaeaea">
        <img
          style="
            height: 55px;
            width: 55px;
            margin-right: 5px;
            vertical-align: middle;
          "
          v-lazy="logo"
          class="image"
        /><span
          style="
            font-size: 18px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #4a4a4a;
            line-height: 27px;
          "
          >酷炫脑客服</span
        >
      </div>
      <div
        style="
          padding-bottom: 27px;
          background: #fff;
          border-radius: 35px;
          text-align: center;
        "
      >
        <img
          v-lazy="showPop.image"
          style="width: 100%; height: auto"
          class="pop-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myServer",
  data() {
    return {
      logo: require("./../../../assets/img/logos.png"),
      showPop: {
        image: require("./../../../assets/img/test/erweima.png"),
      },
    };
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  background: #f9f9f9;
  height: 100vh;
  padding-top: 71px;

  .pop {
    margin: 0 auto;
    width: 342px;
    height: 450px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.22);
    border-radius: 12px;
  }
}

.popFt {
  font-size: 26px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 50px;
}
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
</style>
